"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.PlayerEvents = exports.HtmlVideoElementEvents = exports.PlaybackState = void 0;
exports.PlaybackState = {
    IDLE: "idle",
    LOADING: "loading",
    PLAYING: "playing",
    PAUSED: "paused",
    BUFFERING: "buffering",
    SEEKING: "seeking",
    ENDED: "ended",
    ERROR: "error",
};
exports.HtmlVideoElementEvents = {
    ERROR: "error",
    LOADEDMETADATA: "loadedmetadata",
    LOADSTART: "loadstart",
    LOADEDDATA: "loadeddata",
    CANPLAY: "canplay",
    CANPLAYTHROUGH: "canplaythrough",
    PLAY: "play",
    PLAYING: "playing",
    PAUSE: "pause",
    ENDED: "ended",
    TIMEUPDATE: "timeupdate",
    RATECHANGE: "ratechange",
    VOLUMECHANGE: "volumechange",
    SEEKED: "seeked",
    SEEKING: "seeking",
    STALLED: "stalled",
    WAITING: "waiting",
};
exports.PlayerEvents = {
    PLAY: "player:play",
    PAUSE: "player:pause",
    STOP: "player:stopped",
    START: "player:start",
    RESUME: "player:resume",
    PLAYING: "player:playing",
    SEEKING: "player:seeking",
    SEEK_TIME_CHANGE: "player:seek_time_change",
    SEEKED: "player:seeked",
    TIME_UPDATE: "player:timeupdate",
    ENDED: "player:ended",
    VOLUME_CHANGE: "player:volumechange",
    ERROR: "player:error",
    CAST_ERROR: "player:cast_error",
    LOADING: "player:loading",
    LOADED: "player:loaded",
    LOAD_START: "player:load_start",
    BUFFERING: "player:buffering",
    BUFFERED: "player:buffered",
    ID3: "player:id3",
    BITRATE_CHANGED: "player:bitrate_changed",
    CDN_CHANGED: "player:cdn_changed",
    AUDIO_CHANGED: "player:audio_changed",
    SUBTITLE_CHANGED: "player:subtitle_changed",
    LICENSE_EXPIRED: "player:license_expired",
    DROPPED_FRAMES: "player:dropped_frames",
    DRM_UPDATE: "player:drm:update",
    STATE_CHANGED: "player:state_changed",
    PROGRAM_CHANGED: "player:program_changed",
    NOT_ENTITLED: "player:not_entitled",
    BLACKOUT: "player:blackout",
    EMPTY_SLOT: "player:empty_slot",
    CAST_START: "player:cast:start",
    CAST_STOP: "player:cast:stop",
    AIRPLAY_START: "player:airplay:start",
    AIRPLAY_STOP: "player:airplay:stop",
    AD_START: "player:ad:start",
    AD_COMPLETE: "player:ad:complete",
    ADBLOCK_START: "player:adblock:start",
    ADBLOCK_COMPLETE: "player:adblock:complete",
    INTRO_START: "player:intro:start",
    INTRO_END: "player:intro:end",
    CHAPTER_START: "player:chapter:start",
    CHAPTER_END: "player:chapter:end",
    MARKER: "player:marker",
    METADATA_EVENT: "player:metadata_event",
    SESSION_ACQUIRED: "player:session_acquired",
    PLAYER_SETUP_COMPLETED: "player:setup_completed",
    ENTITLEMENT_GRANTED: "player:entitlement_granted",
};
exports.ContentType = {
    VOD: "vod",
    LIVE: "live",
    AD: "ad",
    PODCAST: "podcast",
};
//# sourceMappingURL=player.js.map